import React, { useState, useEffect } from "react";
import {
  Box,
  CircularProgress,
  LinearProgress,
  Typography,
  Paper
} from "@mui/material";
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { getText } from "../utils/texts";

const LoadingScreen = ({ language }) => {
  const [progress, setProgress] = useState(0);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        // More realistic progress that slows down as it gets closer to 100%
        const increment = Math.max(1, Math.floor((100 - prevProgress) / 10));
        return Math.min(prevProgress + increment, 99);
      });
    }, 300);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
        width: "100%",
        p: 3
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "90%",
          width: 320
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            mb: 3
          }}
        >
          <QuestionAnswerIcon
            sx={{
              fontSize: 60,
              opacity: 0.7,
              color: "primary.main"
            }}
          />
          <CircularProgress
            size={80}
            thickness={2}
            sx={{
              position: "absolute",
              top: -10,
              left: -10,
              zIndex: 1,
            }}
          />
        </Box>

        <Typography variant="h6" gutterBottom>
          {getText("loadingUserInfo", language)}
        </Typography>
        
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
          {getText("loadingMessage", language)}
        </Typography>

        <Box sx={{ width: "100%", mb: 1 }}>
          <LinearProgress 
            variant="determinate" 
            value={progress} 
            sx={{ 
              height: 8, 
              borderRadius: 4,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              "& .MuiLinearProgress-bar": {
                borderRadius: 4,
              }
            }} 
          />
        </Box>
        
        <Typography variant="body2" color="text.secondary">
          {`${Math.round(progress)}%`}
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoadingScreen;